import { sendToLurker as e } from "../Lurker/Lurker.js";
const t = () => {
  e({
    eventType: "click",
    objectDetail: "links",
    objectName: "breadcrumb"
  });
};
export { t as sendClickEvent };